'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookPostType = function FacebookPostType(_ref) {
  var asset = _ref.asset;

  var pt = void 0;
  pt = asset.postType;

  if (!pt) {
    pt = asset.isVideo ? 'video' : 'photo';
  }

  var types = {
    video: _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube play', color: 'blue' }),
    photo: _react2.default.createElement(_semanticUiReact.Icon, { name: 'image', color: 'blue' }),
    post: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' }),
    pagepost: _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment outline', color: 'blue' })
  };
  return types[pt];
};

exports.default = FacebookPostType;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/facebook-post-type/index.js
 ** module id = 2624
 ** module chunks = 0
 **/